import { createContext } from 'react';
import { AppSettings, defaultAppSettings } from '@wix/search-settings-client';

export const AppSettingsContext = createContext<AppSettings>(
  defaultAppSettings,
);
